import React from "react";
import { USER_TYPE_TEXT, useTranslation } from "hhn-commons";
import { FilterDataType, USER_TYPE } from "@home-health-notify/domain";

const FilterTooltipText = ({
  filterTooltipData,
}: {
  filterTooltipData: FilterDataType | undefined;
}) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "userDirectory" });

  const userTypeFilters = filterTooltipData?.userType
    .map(
      (userType: USER_TYPE) =>
        USER_TYPE_TEXT[userType as keyof typeof USER_TYPE_TEXT],
    )
    .join(", ");

  const userRoleFilters = filterTooltipData?.userRole.join(", ");

  const showUserTypeFilters =
    filterTooltipData?.userType && filterTooltipData?.userType.length > 0;
  const showUserRoleFilters =
    filterTooltipData?.userRole && filterTooltipData?.userRole.length > 0;
  const showSeparator =
    filterTooltipData?.userType && filterTooltipData?.userType.length > 0;

  return (
    <>
      {showUserTypeFilters && (
        <span>
          {tNs("filter.userType")}: {userTypeFilters}
        </span>
      )}
      {showSeparator && <br />}
      {showUserRoleFilters && (
        <span>
          {tNs("filter.userRole")}: {userRoleFilters}
        </span>
      )}
    </>
  );
};

export default FilterTooltipText;
